import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import Modal from '@/components/elements/AutoBlockedModal/Modal';

import ExpressSetupFAQItem from './ExpressSetupFAQItem';
import { useFAQWithDynamicDays } from './hooks';

interface Props {
  visible?: boolean;
  numberOfDaysBeforePlanStart?: number;
  onToggleVision: (value: boolean) => void;
}

const FAQModal: React.FC<Props> = ({
  visible,
  numberOfDaysBeforePlanStart,
  onToggleVision,
}) => {
  const dynamicFAQArray = useFAQWithDynamicDays(numberOfDaysBeforePlanStart);
  return (
    <>
      <Modal
        visible={!!visible}
        onSetVisible={() => onToggleVision(false)}
        data-testid="edit-address-wizard-modal"
      >
        <Box direction="column">
          <Box direction="row" align="center" justify="center" pad={{ bottom: 'spacing24' }}>
            <Text size="2xl" color="textTitle" weight="bold">FAQ</Text>
          </Box>
          <Box gap="s">
            {dynamicFAQArray?.map((item, index) => (
              <ExpressSetupFAQItem 
                key={index} 
                question={item.question} 
                answer={item.answer}
                index={index}
              />
            ))}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default FAQModal;
